export const variables = {
  PRIMARY: '{p}',
  SECONDARY: '{s}',
  TERTIARY: '{t}',
  BACKGROUND: '{b}',
  SECONDARY_BACKGROUND: '{sb}',
  TEXT: '{tt}'
};

export function isValidHexCode(value) {
  // Regex to check if it's a valid hex code (3 or 6 digit hex code)
  return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(`#${value}`);
}

export function isValidVariable(value) {
  // Check if the value is one of the predefined variables
  const validVariables = [
    variables.PRIMARY,
    variables.SECONDARY,
    variables.TERTIARY,
    variables.BACKGROUND,
    variables.SECONDARY_BACKGROUND,
    variables.TEXT
  ];
  return validVariables.includes(value);
}

export function cssVariableToVariable(value) {

  if (value === 'var(--startup-primary-color)') {
    return variables.PRIMARY;
  } else if (value === 'var(--startup-secondary-color)') {
    return variables.SECONDARY;
  } else if (value === 'var(--startup-tertiary-color)') {
    return variables.TERTIARY;
  } else if (value === 'var(--startup-primary-background-color)') {
    return variables.BACKGROUND;
  } else if (value === 'var(--startup-secondary-background-color)') {
    return variables.SECONDARY_BACKGROUND;
  } else if (value === 'var(--startup-text-color)') {
    return variables.TEXT;
  }

  return value;

}

export function normalizeValue(value) {

  if (isValidCSSVariable(value) === true) {
    return cssVariableToVariable(value);
  }

  if (value === null) {
    return '';
  }

  return value.replace('#', '');

}

export function isValidCSSVariable(cssVariable = '') {

  if (cssVariable === null) {
    return false;
  }

  return cssVariable.startsWith('var(--startup-');

}

export function variableToHexCode(application, cssVariable) {

  const startup = application.getCurrentStartup();

  if (cssVariable === 'var(--startup-primary-color)') {
    return startup.theme.colors.primary;
  } else if (cssVariable === 'var(--startup-secondary-color)') {
    return startup.theme.colors.secondary;
  } else if (cssVariable === 'var(--startup-tertiary-color)') {
    return startup.theme.colors.tertiary;
  } else if (cssVariable === 'var(--startup-primary-background-color)') {
    return startup.theme.colors.background;
  } else if (cssVariable === 'var(--startup-secondary-background-color)') {
    return startup.theme.colors.secondaryBackground;
  } else if (cssVariable === 'var(--startup-text-color)') {
    return startup.theme.colors.text;
  }

}

export function variableToCSSVariable(val) {

  let mappedVariable = '';

  if (val === variables.PRIMARY) {
    mappedVariable = '--startup-primary-color';
  } else if (val === variables.SECONDARY) {
    mappedVariable = '--startup-secondary-color';
  } else if (val === variables.TERTIARY) {
    mappedVariable = '--startup-tertiary-color';
  } else if (val === variables.BACKGROUND) {
    mappedVariable = '--startup-primary-background-color';
  } else if (val === variables.SECONDARY_BACKGROUND) {
    mappedVariable = '--startup-secondary-background-color';
  } else if (val === variables.TEXT) {
    mappedVariable = '--startup-text-color';
  }

  return `var(${mappedVariable})`;

}

export function hexCodeToVariable(application, hexCode) {

  const startup = application.getCurrentStartup();
  const colors = startup.theme.colors;

  if (hexCode === colors.primary) {
    return variables.PRIMARY;
  } else if (hexCode === colors.secondary) {
    return variables.SECONDARY;
  } else if (hexCode === colors.tertiary) {
    return variables.TERTIARY;
  } else if (hexCode === colors.background) {
    return variables.BACKGROUND;
  } else if (hexCode === colors.secondaryBackground) {
    return variables.SECONDARY_BACKGROUND;
  } else if (hexCode === colors.text) {
    return variables.TEXT;
  } else {
    return null;
  }

}

export function getPrefix(inputValue) {
  if (isValidHexCode(inputValue)) {
    return '#';
  } else if (isValidVariable(inputValue)) {
    return 'VAR';
  }
  return '?';
};